import React, { useEffect } from "react";
import AppData from "../../../../config/appData.json";
import handlePostApi from "../../../../api/HandlePostApi";
import PatchData from "../../../../api/PatchData";

const SelectParam = ({ headers, handleOnChange, label, value }) => {
  return (
    <div className="me-5 mb-3">
      <div>
        <label htmlFor="config" className="form-label">
          {label}
        </label>
      </div>
      <select onChange={handleOnChange} value={value}>
        <option className="form-control">Select Header</option>
        {headers &&
          headers.map((header, index) => (
            <option className="form-control" key={index} value={header}>
              {header}
            </option>
          ))}
      </select>
    </div>
  );
};

const SelectParams = ({ params = [], headers }) => {
  return (
    <div className="d-flex flex-wrap mt-4">
      {params.map((param, index) => (
        <SelectParam
          key={index}
          label={param.label}
          handleOnChange={param.handleOnChange}
          headers={headers}
          value={param.value}
        />
      ))}
    </div>
  );
};

export default function ConfigSetting({
  setMessage,
  setIsModalOpen,
  config = {},
}) {
  const [switchName, setSwitchName] = React.useState(config?.name || "");
  const [headers, setHeaders] = React.useState(
    config?.rawColumns?.join(",") || ""
  );
  const [transactionDate, setTransactionDate] = React.useState(
    config?.commonColumns.transaction_date || ""
  );
  const [rrn, setRrn] = React.useState(config?.commonColumns.rrn || "");
  const [merchantId, setMerchantId] = React.useState(
    config?.commonColumns.merchant_id || ""
  );
  const [terminalId, setTerminalId] = React.useState(
    config?.commonColumns.terminal_id || ""
  );
  const [transactionsAmount, setTransactionsAmount] = React.useState(
    config?.commonColumns.transaction_amount || ""
  );
  const [headerRowNumber, setHeaderRowNumber] = React.useState(
    config?.headerRowNumber || ""
  );
  const [errMessage, setErrMessage] = React.useState("");

  const HandleOnChange = (e, setChangeOption) => {
    e.preventDefault();
    setChangeOption(e.target.value);
  };

  const data = {
    name: switchName,
    headers: headers,
    transaction_date: transactionDate,
    rrn: rrn,
    merchant_id: merchantId,
    terminal_id: terminalId,
    transaction_amount: transactionsAmount,
    header_row_number: headerRowNumber,
  };
  const headersData = headers && headers.split(",");

  const handleSaveConfig = async (e) => {
    e.preventDefault();
    try {
      let response;
      if (config !== null) {
        // Edit existing config
        const url =
          AppData.PAYMENT_URL + `config/switch/settlements/${config.name}`;
        response = await PatchData(url, data);
      } else {
        // Create new config
        const url = AppData.PAYMENT_URL + "config/switch/settlements";
        response = await handlePostApi(url, data);
      }
      setMessage(response.message);
      setIsModalOpen(false);
    } catch (error) {
      console.error("Error", error);
      setErrMessage(() => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.error &&
          typeof error.response.data.fields === "object"
        ) {
          // Extract the error messages from the fields object
          const errorMessages = Object.values(error.response.data.fields)
            .flat()
            .join(", ");
          return errorMessages;
        }
        return error.message || "Error occurred";
      });
    }
  };

  return (
    <div className="settlement-config-settings">
      <h3 className="heading">
        {config !== null
          ? "Edit Settlement Switch Configuration"
          : "New Settlement Switch Configuration"}
      </h3>
      {errMessage && <small>{errMessage}</small>}
      <hr />
      <div>
        <form className="" onSubmit={handleSaveConfig}>
          <div className="row pb-4">
            <div className="col-4">
              <label htmlFor="config" className="form-label">
                Enter Switch Name
                <span className="text-danger"> *</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Switch Name"
                value={switchName}
                onChange={(e) => setSwitchName(e.target.value)}
              />
            </div>
            <div className="col-4">
              <label htmlFor="config" className="form-label">
                Enter Header Row Number
                <span className="text-danger"> *</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Header Row Number"
                value={headerRowNumber}
                onChange={(e) => setHeaderRowNumber(e.target.value)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-8 h-100">
              <label htmlFor="config" className="form-label">
                Enter Headers
                <span className="text-danger"> *</span>
              </label>
              <textarea
                type="text"
                className="form-control"
                placeholder="Enter Headers Separated by Commas"
                value={headers}
                onChange={(e) => setHeaders(e.target.value)}
              />
            </div>
          </div>
          <SelectParams
            headers={headersData}
            params={[
              {
                label: "Merchant Id",
                handleOnChange: (e) => HandleOnChange(e, setMerchantId),
                value: merchantId,
              },
              {
                label: "Terminal Id",
                handleOnChange: (e) => HandleOnChange(e, setTerminalId),
                value: terminalId,
              },
              {
                label: "Transaction Date",
                handleOnChange: (e) => HandleOnChange(e, setTransactionDate),
                value: transactionDate,
              },
              {
                label: "Rrn",
                handleOnChange: (e) => HandleOnChange(e, setRrn),
                value: rrn,
              },
              {
                label: "Transaction Amount",
                handleOnChange: (e) => HandleOnChange(e, setTransactionsAmount),
                value: transactionsAmount,
              },
            ]}
          />
          <button className="btn">
            {config !== null ? "Update Config" : "Save Config"}
          </button>
        </form>
      </div>
    </div>
  );
}
